export const Orders = {
  PhoneNumber: 'PhoneNumber',
  PasswordFromPhone: 'PasswordFromPhone',
  ChooseVariante: 'ChooseVariante',
  TypeOfService: 'TypeOfService',
  ChooseSpecialist: 'ChooseSpecialist',
  ChooseTime: 'ChooseTime',
  Mail: 'Mail',
  Info: 'Info',
};
